"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RenderFieldWrapper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _classnames = _interopRequireDefault(require("classnames"));

var _validation = require("../../validation");

var _FieldTitle = _interopRequireDefault(require("../../ui/FieldTitle"));

var _FieldDescription = _interopRequireDefault(require("../../ui/FieldDescription"));

var _FieldInfo = _interopRequireDefault(require("../../form/FieldInfo"));

var _formatField = require("../../utils/formatField");

var _normalizeField = _interopRequireDefault(require("../../utils/normalizeField"));

var _types = require("../../types");

var _validation2 = require("../../types/validation");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _validation2.InheritedFieldValidation;
});

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var OptionsElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionsElementDefinition;
});

var FieldProps = _flowRuntime["default"].tdz(function () {
  return _reduxForm.FieldProps;
});

var Node = _flowRuntime["default"].tdz(function () {
  return _react.Node;
});

var ComponentType = _flowRuntime["default"].tdz(function () {
  return _react.ComponentType;
});

var RenderFieldProps = _flowRuntime["default"].type("RenderFieldProps", _flowRuntime["default"].intersection(_flowRuntime["default"].object(_flowRuntime["default"].property("fieldKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("inputStyle", _flowRuntime["default"].object()), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"]())), _flowRuntime["default"].ref(FieldProps)));

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("displayField", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("field", _flowRuntime["default"].ref(FieldElementDefinition)), _flowRuntime["default"].property("noOptionalLabel", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("onBlur", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].any()), _flowRuntime["default"]["return"](_flowRuntime["default"].any())), true), _flowRuntime["default"].property("onChange", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].any()), _flowRuntime["default"]["return"](_flowRuntime["default"].any())), true), _flowRuntime["default"].property("renderField", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", RenderFieldProps), _flowRuntime["default"]["return"](_flowRuntime["default"].ref(Node)))), _flowRuntime["default"].property("inheritedFieldValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedFieldValidation)), true)));

var RenderProps = _flowRuntime["default"].type("RenderProps", _flowRuntime["default"].intersection(_flowRuntime["default"].object(_flowRuntime["default"].property("field", _flowRuntime["default"].union(_flowRuntime["default"].ref(FieldElementDefinition), _flowRuntime["default"].ref(OptionsElementDefinition))), _flowRuntime["default"].property("fieldKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("noOptionalLabel", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("renderField", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", RenderFieldProps), _flowRuntime["default"]["return"](_flowRuntime["default"].ref(Node))))), _flowRuntime["default"].ref(FieldProps)));

var RenderFieldWrapper = function RenderFieldWrapper(_arg) {
  var custom = _arg.custom,
      field = _arg.field,
      fieldKey = _arg.fieldKey,
      input = _arg.input,
      isRequired = _arg.isRequired,
      meta = _arg.meta,
      noOptionalLabel = _arg.noOptionalLabel,
      renderField = _arg.renderField;
  var fieldClass = (0, _classnames["default"])('group', field.type, field.key, field.ui && field.ui.classes);
  var inputClass = (0, _classnames["default"])(field.type, {
    error: meta.touched && meta.error,
    success: meta.valid && input.value
  });
  var controlClass = (0, _classnames["default"])('control', {
    'control--checkbox': field.type === 'checkbox',
    'control--radio': field.type === 'radio' || field.type === 'ethnicity',
    bordered: field.ui && field.ui.border,
    'control--small': field.ui && field.ui.classes === 'small'
  });
  var indicatorClass = (0, _classnames["default"])('control__indicator', {
    'control__indicator--small': field.ui && field.ui.classes === 'small',
    error: meta.touched && meta.error
  });
  var inputStyle = {
    inputClass: inputClass,
    controlClass: controlClass,
    indicatorClass: indicatorClass
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: fieldClass
  }, /*#__PURE__*/_react["default"].createElement(_FieldTitle["default"], {
    field: field,
    isRequired: noOptionalLabel ? true : isRequired
  }), /*#__PURE__*/_react["default"].createElement(_FieldDescription["default"], {
    field: field,
    position: "before"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-wrapper"
  }, renderField && renderField({
    custom: custom,
    fieldKey: fieldKey,
    input: input,
    inputStyle: inputStyle,
    isRequired: isRequired,
    meta: meta
  }), meta.asyncValidating && /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader loader--input"
  })), meta.touched && (meta.error && /*#__PURE__*/_react["default"].createElement("span", {
    className: "error-message" // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: meta.error
    }
  }) || meta.warning && /*#__PURE__*/_react["default"].createElement("span", {
    className: "warn-message"
  }, meta.warning)), /*#__PURE__*/_react["default"].createElement(_FieldDescription["default"], {
    field: field,
    position: "after"
  }), field.info && /*#__PURE__*/_react["default"].createElement(_FieldInfo["default"], {
    className: field.key,
    info: field.info
  }));
};

exports.RenderFieldWrapper = RenderFieldWrapper;
RenderFieldWrapper.defaultProps = {
  noOptionalLabel: false
};
/**
 * This 'field' is responsible for field level validation, and will only render error messaging for failed validation
 *
 * @param field
 * The field
 * @param fieldValidationRules
 * An array of validators to be run for the field
 * @param subFieldRules
 * An array of applicable rules defined in parent components and matched to the field
 */

var FormFieldWrapper = function FormFieldWrapper(_arg2) {
  var disabled = _arg2.disabled,
      displayField = _arg2.displayField,
      field = _arg2.field,
      onBlur = _arg2.onBlur,
      onChange = _arg2.onChange,
      noOptionalLabel = _arg2.noOptionalLabel,
      renderField = _arg2.renderField,
      inheritedFieldValidation = _arg2.inheritedFieldValidation;
  var inheritedFieldRules = (0, _validation.getInheritedFieldValidation)(field.key, inheritedFieldValidation);
  return displayField ? /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
    component: RenderFieldWrapper,
    disabled: disabled,
    field: field,
    fieldKey: field.key,
    format: (0, _formatField.formatField)(field.type),
    isRequired: (0, _validation.isRequiredField)((0, _validation.validationRules)(field, inheritedFieldRules)),
    key: field.key,
    name: field.key,
    normalize: (0, _normalizeField["default"])(field.normalize),
    noOptionalLabel: noOptionalLabel,
    onBlur: onBlur,
    onChange: onChange,
    parse: (0, _formatField.parseField)(field.type),
    renderField: renderField,
    validate: (0, _validation.getFieldValidationRules)(field, inheritedFieldRules)
  }) : null;
};

FormFieldWrapper.defaultProps = {
  disabled: undefined,
  displayField: false,
  onBlur: undefined,
  onChange: undefined,
  noOptionalLabel: false,
  inheritedFieldValidation: []
};
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var field = ownProps.field;
  var conditionalField = field.ui && field.ui.conditionalField;
  var conditionalFieldValue = selector(state, conditionalField);
  return {
    displayField: !conditionalField || conditionalField && conditionalFieldValue
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps)(FormFieldWrapper);

exports["default"] = _default;